import { Component, ElementRef, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';

@Component({
  selector: 'dialog-graphic',
  templateUrl: './dialog-graphic.component.html',
  styleUrls: ['./dialog-graphic.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DialogGraphicComponent extends DialogFullScreenComponentContent {

  public stock: any;

  constructor(
    private dialogReference: MatDialogRef<DialogGraphicComponent>,
    public element: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public store: Store<AppState>) {
      super(element, '.overlay-graphic');

      this.stock = data;
  }

  public dispose() {
    super.close(this.dialogReference, null);
  }
}
